// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { DisplayHelperService } from '../shared/display-helper.service';

@Component({
    selector: 'page-performance-audit-display-informative',
    standalone: false,
    template: `
        <div class="page-performance-audit-display page-performance-audit-display-informative">
            <mon-markdown-viewer [monMarkdown]="audit.description"></mon-markdown-viewer>
            <table *ngIf="showTable"
                   class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th [ngClass]="heading.cssClass"
                        *ngFor="let heading of headings; trackBy: trackByIndex">
                        {{heading.text}}
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items">
                        <td class="text-wrap text-ellipsis"
                            [ngClass]="column.cssClass"
                            *ngFor="let column of item.columns; trackBy: trackByIndex"
                            [innerHTML]="column.text">
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="isTypeCriticalRequestChain" class="pb-2">
                <p translate
                   [translate-args]="{latency: (audit.details.longestChain.duration | monNumber:'0')}">
                    Maximum critical path latency: <strong>[[latency]] ms </strong>
                </p>
                <page-performance-audit-display-informative-request-chain [chains]="audit.details.chains">
                </page-performance-audit-display-informative-request-chain>
            </div>
        </div>
    `,
})
export class PagePerformanceAuditDisplayInformativeComponent implements OnInit {
    @Input() audit: any;

    headings: any[] = [];
    items: any[] = [];
    showTable: boolean = false;
    isTypeCriticalRequestChain: boolean = false;

    constructor (private displayHelperService: DisplayHelperService) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.showTable = this.displayHelperService.hasDetails(this.audit.details) &&
            (this.displayHelperService.isDetailTypeTable(this.audit.details.type) ||
            this.displayHelperService.isDetailTypeOpportunity(this.audit.details)) &&
            this.displayHelperService.hasDetailsTypeContent(this.audit.details);

        if (this.showTable) {
            this.headings = this.displayHelperService.getHeadings(this.audit.details);
            this.items = this.displayHelperService.getItems(this.audit.details);
            this.isTypeCriticalRequestChain = this.displayHelperService.isTypeCriticalRequestChain(this.audit.details);
        }
    }

    trackByIndex (index: number, item: any): any {
        return index;
    }
}
